import $ from "jquery"
// import "slick-carousel";
import Swiper from "swiper"
import { Pagination, Zoom } from "swiper/modules"
import modalCart from "scripts/components/modals/modalCart"
import modalPreviewSlider from "scripts/components/modals/modalPreviewSlider"
import FacebookPixel from "scripts/components/FacebookPixel/FBQ"
import renderStoreSelector from "scripts/components/react/StoreSelector"
import eSputnik from "scripts/components/eSputnik"
import { GUID } from "scripts/utils"
import { GAAddToCart } from "scripts/components/ga/add_to_cart"
import GlobalState from "scripts/components/globalState"
import { GAViewItem } from "scripts/components/ga/view_item"
import { centerElementInContainer } from "scripts/utils/centerElementInContainer"
import { renderBullet } from "scripts/components/sliders"
import addGlobalEvent from "scripts/utils/addGlobalEvent"
import deferAction from "scripts/utils/deferAction"
import { renderModalInfoCentered } from "./react/ModalInfoCentered"
import { modalInfoCenteredState } from "./react/ModalInfoCentered/store"
import { addProduct } from "./react/api"
import recaptchaEnterprise, { RECAPTCHA_ACTIONS } from "scripts/components/recaptcha/recaptcha";

window.productsIDs = []
class CurrentProductState extends GlobalState {
  constructor(val) {
    super(val)
    // this.value = value
  }
  isInCart() {
    return window.productsIDs?.includes(this.value.id)
  }
  getValue() {
    const value = this.value
    return {
      ...value,
      code_parent: window.productDetails.id,
    }
  }
}
window.currentProduct = new CurrentProductState({})
const currencyFormat = (value, currencySign) => {
  const formattedNumber = value.toLocaleString("uk-UA", { maximumFractionDigits: 0 })
  return currencySign ? `${formattedNumber} ${currencySign}` : formattedNumber
}

FacebookPixel.viewContent()

const AJAX = ""
const locale = $("html").attr("lang")

const createCreditBlock = ({ credits, sale }) => {
  return `<div class="buy-controls__item product__buy_credit js-credit">
  <div class="content flex-c-c">
      <div class="credit flex-s">
          ${credits
            .filter((credit) => credit.show_as_icon)
            .map(
              (credit) =>
                `<div class="credit__item">
                  <svg class="icon-${credit["code"]}">
                      <use xlink:href="#${credit["code"]}"/>
                  </svg>
                  <span class="credit__month">${Math.max.apply(
                    null,
                    credit["month"],
                  )}</span>
              </div>`,
            )
            .join("")}
      </div>
      <div class="sale flex-c">
          ${window.phrases.product.buy_credit_from_to.replace(
            ":count",
            currencyFormat(sale),
          )} 
      </div>
  </div>
  <div class="wb-btn btn-white modal-btn" data-target="modal-credit">
      <span>${window.phrases.product.buy_credit_button_title}</span>
  </div>
</div>`
}

const productPage = () => {
  const refs = {
    buyButtons: document.querySelectorAll(
      ".js_product_buy_button span, .js_fixed_product_buy span",
    ),
    oldPrice: $(".js_selected_old"), // old - old price
    oldPriceBlock: $(".js_selected_old").parent(),
    currentPrice: $(".js_selected_current"), // current - Current price
    credit: $(".js_selected_sale"),
    creditBlock: $(".js-credit"),
    cashbackPrice: $(".js_product_auth_cashback, .js_product_cashback_for_authed"),
    discountPercent: $(".js_product_auth_discount"),
    code: $(".js_selected_code"), // code - art
    stockPhrase: $(".js_selected_stock_phrase"), // stock-phrase - text of offline stores block
    stockBlock: $(".js_product_book_block"),
    stockButton: $(".js_stock"),
    buyInfoBlock: $(".buy-info"),
    charsIconsBlock: $(".product__chars"),
    charsListBlock: $(".about-item.char ul"),
    discountBlock: $(".product-buy .old-price-block"),
    productBuyBlock: document.querySelector(".product-buy"),
    productPriceBlock: document.querySelector(".js-price"),
    fixedBlock: document.querySelector(".product__fixed"),
  }

  // const charsExcludedFromIcons = ['size']
  const charsInIconsBlockAllow = [
    "weight_product",
    "vid_metala",
    "haracteristica_bril",
    "color_metal",
    "vstavka",
  ]
  // const charsOrder = ['weight_product', 'vid_metala', 'haracteristica_bril', 'color_metal', 'vstavka', 'size']

  // Set current product
  window.currentProduct.setValue({
    category: window.productDetails.category || "",
    // One product
    ...(window.productOffers[0] ||
      // Or find main size
      Object.values(window.productOffers).find((item) => item.is_main) ||
      // Or select first offer
      window.productOffers[Object.keys(window.productOffers)[0]]),
  })

  const setBuyButtonText = () => {
    const buyText = window.phrases.cart.buy
    const inCart = window.phrases.cart.in_basket

    refs.buyButtons.forEach((el) => {
      if (window.currentProduct.isInCart()) {
        // eslint-disable-next-line no-param-reassign
        el.textContent = inCart
        el.setAttribute("data-target", "modal-cart")
        el.classList.add("modal-btn")
      } else {
        // eslint-disable-next-line no-param-reassign
        el.textContent = buyText
        el.removeAttribute("data-target")
        el.classList.remove("modal-btn")
      }
    })
  }

  const setCharUnit = (code, title) => {
    if (code === "weight_product") {
      // eslint-disable-next-line no-irregular-whitespace
      return `${title} ${window.phrases.product.weight_uom}`
    }
    return title
  }

  const sizes = () => {
    const sizesHolder = $(".product-sizes")
    const renderPrice = () => {
      const currentProduct = window.currentProduct.getValue()
      const properties = Object.values(currentProduct.properties)

      refs.currentPrice.text(currencyFormat(currentProduct.current))
      refs.code.text(currentProduct.code)
      refs.discountPercent.text(`${currentProduct.discount_percent}%`)
      refs.cashbackPrice.text(
        `${currencyFormat(currentProduct.cashback_price)} ${
          currentProduct.currency_icon
        }`,
      )

      if (currentProduct.old) {
        refs.oldPrice.text(currencyFormat(currentProduct.old))
        refs.oldPriceBlock.show()
      } else {
        refs.oldPriceBlock.hide()
      }

      if (currentProduct["is-stock"]) {
        refs.stockPhrase.text(currentProduct["stock-phrase"])
        refs.stockButton.data("id", currentProduct.id)
        refs.stockBlock.show()
      } else {
        refs.stockBlock.hide()
      }
      // Render discount percent in actions block
      if (currentProduct["offer_discount_percent"]) {
        const discountBlockElement = refs.discountBlock[0]
        const discountElement = discountBlockElement?.querySelector(".product-card__label")
        const discountElementContent = `-${currentProduct["offer_discount_percent"]} <span>%<span>`
        // Set discount percent if dom element exists
        if (discountElement) {
          discountElement.innerHTML = discountElementContent
        } else {
          // discount label does not exist. Create new dom element
          const newElementLayout = `<div class="product-card__label">${discountElementContent}</div>`
          discountBlockElement.insertAdjacentHTML("beforeend", newElementLayout)
        }
      } else {
        // Remove dom element
        const discountElement = refs.discountBlock.find(".product-card__label")[0]
        discountElement?.remove()
      }

      setBuyButtonText()

      // Render chars in buyInfoBlock (size and weight)
      const SIZE_AND_WEIGHT_PROPERTY = ["size", "weight_product"]
      SIZE_AND_WEIGHT_PROPERTY.forEach((property) => {
        const elementToInsert = refs.buyInfoBlock.find(`.js_selected_${property}`)
        if (!currentProduct.properties[property]) {
          elementToInsert.parent().remove()
          return
        }
        const modifiedTitle = setCharUnit(
          currentProduct.properties[property].code,
          currentProduct.properties[property].title,
        )

        const translationCode = property === "weight_product" ? "buy_weight" : "buy_size"

        const createBuyInfoItem = (property, translationCode, modifiedTitle) => {
          return `<div class="buy-info__item">
                    ${window.phrases.product[translationCode]}
                    <span class="num js_selected_${property}">${modifiedTitle}</span>
                  </div>`
        }
        if (elementToInsert.length === 0) {
          refs.buyInfoBlock.append(createBuyInfoItem(property, translationCode, modifiedTitle))
        } else {
          elementToInsert.text(modifiedTitle)
        }
      })

      // Render chars
      const chars = properties.filter((item) => item.show_on_detail)

      const charsIconsBlockNodeList = refs.charsIconsBlock[0]?.children
      const charsListBlockNodeList = refs.charsListBlock[0]?.children
      const charsIconsBlockNodeListArray = Object.values(charsIconsBlockNodeList)
      const charsListBlockNodeListArray = Object.values(charsListBlockNodeList)

      // Render chars in icons block
      const charsToChangeInIconsBlock = charsIconsBlockNodeListArray.filter(
        (item) => item.dataset.isOfferProperty === "true",
      )

      const createIcon = (code, title) => {
        const modifiedTitle = setCharUnit(code, title)
        const newElement = refs.charsIconsBlock[0]
          ?.querySelector(".product__chars_item")
          .cloneNode(true)
        // Find old code in html of new element
        const oldCode = newElement.dataset.propertyCode
        // Replace through html code of new element oldCode to code
        newElement.innerHTML = newElement.innerHTML.replaceAll(oldCode, code)
        newElement.querySelector(".text").children[0].textContent = modifiedTitle
        newElement.dataset.propertyCode = code
        newElement.dataset.isOfferProperty = "true"
        // Insert new element with index like in charsToChangeInIconsBlock
        refs.charsIconsBlock[0].appendChild(newElement)
      }

      charsToChangeInIconsBlock.forEach((existingCharItem) => {
        const code = existingCharItem.dataset.propertyCode
        const currentPropertyIndex = chars.findIndex((item) => item.code === code)
        if (currentPropertyIndex !== -1) {
          const { title } = chars[currentPropertyIndex]
          const modifiedTitle = setCharUnit(code, title)
          // eslint-disable-next-line no-param-reassign
          existingCharItem.querySelector(".text").children[0].textContent = modifiedTitle
          chars.splice(currentPropertyIndex, 1)
        } else {
          existingCharItem.remove()
        }
      })

      chars.forEach(({ code, title }) => {
        // If icon included to allowed icons
        if (charsInIconsBlockAllow.includes(code)) {
          const existingElement = refs.charsIconsBlock[0]?.querySelector(
            `[data-property-code="${code}"]`,
          )
          if (existingElement) {
            const modifiedTitle = setCharUnit(code, title)
            existingElement.querySelector(".text").children[0].textContent = modifiedTitle
            existingElement.dataset.isOfferProperty = "true"
          } else {
            createIcon(code, title)
          }
        }
      })

      // Render chars in list block
      const charsToChangeInListBlock = charsListBlockNodeListArray.filter(
        (item) => item.dataset.isOfferProperty === "true",
      )

      const createListItem = ({ code, title, name }) => {
        const modifiedTitle = setCharUnit(code, title)
        const newElement = refs.charsListBlock[0]?.firstElementChild.cloneNode(true)
        if (code === "size") {
          const links = properties.find((item) => item.code === "size").links
          let linkString = "";
          if (links.length) {
            links.forEach((link) => {
              linkString += `<a href="${link.url}">${link.title}</a>`
            })
          }
          newElement.querySelector(".text").innerHTML = linkString;
        } else {
          newElement.querySelector(".text").textContent = modifiedTitle
        }
        // Find old code in html of new element
        newElement.querySelector(".title").textContent = name
        newElement.dataset.propertyCode = code
        newElement.dataset.isOfferProperty = "true"

        refs.charsListBlock[0].appendChild(newElement)
      }
      charsToChangeInListBlock.forEach((existingCharItem) => {
        const code = existingCharItem.dataset.propertyCode
        const currentPropertyIndex = properties.findIndex((item) => item.code === code)
        if (
          currentPropertyIndex !== -1 &&
          properties[currentPropertyIndex].show_on_detail
        ) {
          const { title, links } = properties[currentPropertyIndex]
          const modifiedTitle = setCharUnit(code, title)
          // existingCharItem.querySelector(".text").children[0].textContent = title
          if (links.length) {
            let res = ""
            links.forEach((link) => {
              res += `<a href="${link.url}">${link.title}</a>`
            })
            // eslint-disable-next-line no-param-reassign
            existingCharItem.querySelector(".text").innerHTML = res
          } else {
            // eslint-disable-next-line no-param-reassign
            existingCharItem.querySelector(".text").textContent =
              modifiedTitle
          }
          properties.splice(currentPropertyIndex, 1)
        } else {
          existingCharItem.remove()
        }
      })

      properties.forEach((property) => {
        if (property.show_on_detail && property.is_offer_property) {
          const existingElement = refs.charsListBlock[0]?.querySelector(
            `[data-property-code="${property.code}"]`,
          )
          if (existingElement) {
            const modifiedTitle = setCharUnit(property.code, property.title)
            existingElement.querySelector(".text").textContent = modifiedTitle
            existingElement.querySelector(".title").textContent = property.name
            existingElement.dataset.isOfferProperty = "true"
          } else {
            createListItem(property)
          }
        }
      })

      // Render credit block
      const creditBlock = refs.productBuyBlock.querySelector(".js-credit")
      if (currentProduct["is_show_credits"]) {
        const creditBlockLayout = createCreditBlock(currentProduct)

        if (creditBlock) {
          creditBlock.outerHTML = creditBlockLayout
        } else {
          refs.productPriceBlock.insertAdjacentHTML("afterend", creditBlockLayout)
        }
      } else {
        creditBlock?.remove()
      }
    }

    const updateUrl = (newSize) => {
      const currentPickedSizeFromUrl = window.location.hash.replace("#", "")
      if (newSize === currentPickedSizeFromUrl) {
        return
      }
      const url = new URL(location.href);
      url.hash = newSize
      history.replaceState(null, "", url);
    }

    const updateProductTitle = () => {
      const title = $("h1.wb-title")
      let titleText = title.text()
      const currentSize = currentProduct.getValue().properties.size.title
      if (currentSize) {
        titleText = titleText.replace(
            new RegExp(`\\s*-\\s*${window.phrases.product.picked_size}\\s+.*$`),
            ""
        )
        const newTitle = `${titleText} - ${window.phrases.product.picked_size} ${currentSize}`
        title.text(newTitle)
      }
    }

    if (sizesHolder.length) {
      sizesHolder.on("change", ".size input", function setSize() {
        const $this = $(this)
        const currentSize = $this.parents(".size").data("size")

        window.currentProduct.setValue({
          category: window.productDetails.category || "",
          metal: window.productDetails.metal || "",
          metal_color: window.productDetails.metal_color || "",
          product_collection: window.productDetails.product_collection || "",
          ...window.productOffers[currentSize],
        })

        refs.productPriceBlock.classList.contains("visually-hidden") &&
          refs.productPriceBlock.classList.remove("visually-hidden")

        refs.fixedBlock.classList.contains("visually-hidden") &&
          refs.fixedBlock.classList.remove("visually-hidden")

        deferAction(() => {
          renderPrice()
          GAViewItem(window.currentProduct.getValue())
          updateUrl(currentSize)
          updateProductTitle()
        })
      })
    }

    const pickedSizeFromUrl = window.location.hash.replace("#", "")
    if (pickedSizeFromUrl && !isNaN(+pickedSizeFromUrl)) {
      const input = $(`label[data-size="${pickedSizeFromUrl}"] input`)
      input.prop("checked", true)
      input.trigger("change")
    }
  }

  const imagePreview = () => {
    const smalImage = $(".large-image__list .list-item ")
    const largeImage = $(".large-image__item img")
    const largeImageWebp = $(".large-image__item source")
    const imagesArr = []
    const imagesAlt = []
    const imagesXLArr = []
    const imagesXLWebpArr = []

    $(smalImage).each((_key, item) => {
      const alt = $(item).find("img").attr("alt")

      imagesArr.push($(item).attr("data-large"))
      imagesXLArr.push($(item).attr("data-x-large"))
      imagesXLWebpArr.push($(item).attr("data-x-large-webp"))
      imagesAlt.push(alt)
    })

    smalImage.on("click", function chageSrc() {
      const $this = $(this)
      const container = $this[0].closest(".js_thumbs")
      const attr = $this.attr("data-large")
      const attrWebp = $this.attr("data-large-webp")
      const attrAlt = $this.find("img").attr("alt")
      const windowWidth = window.innerWidth

      smalImage.not($this).removeClass("active")
      $this.addClass("active")

      if (windowWidth < 768) {
        const $thisIndex = $this.index()
        const imageIndex = imagesArr.indexOf(attr)
        const imageIndexLenght = imagesArr.length
        const largeImageSrc = largeImage.attr("src")
        const largeImageAlt = largeImage.attr("alt")

        const setImage = (element, image, alt) => {
          element
            .attr("data-large", image)
            .find("img")
            .attr("src", image)
            .attr("alt", alt)
        }

        if ($thisIndex === 1) {
          const key = imageIndex === imageIndexLenght - 1 ? 0 : imageIndex + 1

          setImage($(smalImage.last()), largeImageSrc, largeImageAlt)
          setImage($(smalImage[1]), imagesArr[key], imagesAlt[key])
        } else {
          const key = imageIndex === 0 ? imageIndexLenght - 1 : imageIndex - 1

          setImage($(smalImage[1]), largeImageSrc, largeImageAlt)
          setImage($(smalImage).last(), imagesArr[key], imagesAlt[key])
        }
      }

      // Center thumb
      centerElementInContainer(container, $this[0])

      largeImage.attr("src", attr).attr("alt", attrAlt)
      largeImageWebp.attr("srcset", attrWebp)
    })

    // Add scroll position to thumbs container as data attribute
    document
      .querySelector(".js_thumbs")
      ?.addEventListener("scroll", function handleScroll() {
        const scrollLeft = Math.round(this.scrollLeft)
        const scrollRight = Math.round(
          this.scrollWidth - this.scrollLeft - this.clientWidth,
        )
        const wrapperEl = this.closest(".large-image__list-wrapper")

        // Add style to this element for ::after pseudo element
        wrapperEl.classList[scrollLeft > 0 ? "add" : "remove"](
          "large-image__list-wrapper--scroll-left",
        )
        // Add style to this element for ::before pseudo element
        wrapperEl.classList[scrollRight > 0 ? "add" : "remove"](
          "large-image__list-wrapper--scroll-right",
        )
      })

    largeImage.on("click", function modalSlider() {
      const $this = $(this)
      const src = $this.attr("src")
      const imageIndex = imagesArr.indexOf(src)
      const disabled = $this.parents(".block-product").hasClass("disabled")

      modalPreviewSlider(imagesXLArr, imageIndex, imagesAlt, imagesXLWebpArr, {
        disabled,
      })
    })
  }

  const productBuy = () => {
    let isAddingToCart
    const headerCart = $(".header-controls__cart")

    const isAdded = (ids = []) => {
      if (!ids.length) return

      setBuyButtonText()

      const selectorAllSizesInCart = ids.map((id) => `[data-id="${id}"]`).join(", ")
      document
        .querySelectorAll(selectorAllSizesInCart)
        .forEach((el) => el.setAttribute("data-cart", true))
    }

    const isRemoved = (id) => {
      const target = $(`[data-id="${id}"]`)

      if (window.currentProduct.value.id === id) {
        setBuyButtonText()
      }

      target.removeAttr("data-cart")
    }
    window.removeFromCart = isRemoved

    const createInCartArr = () => {
      Object.values(window.productOffers).forEach((product) => {
        product.in_cart && window.productsIDs.push(product.id)
      })
    }
    createInCartArr()

    $(document).on(
      "click",
      ".block-product .buy-controls__item .wb-btn.btn-green, .js_fixed_product_buy",
      async (e) => {
        let { id } = window.currentProduct.value;
        // Set new id from storeSelector
        id = e.detail?.productVariantId || id
        const options = []

        if (!window.productsIDs.includes(id) && !isAddingToCart) {
          isAddingToCart = true;
          window.globalCart.setValue((prev) => ({
            ...prev,
            isLoading: true,
          }));
          modalCart.create();
          
          try {
            const response = await addProduct({ id, locale, options })

            const itemsInCart = { ...response.items };
            const itemsInCartCount = Object.keys(itemsInCart).length;
            window.itemsInCart = itemsInCart;
            
            headerCart.attr("data-length", itemsInCartCount);
            headerCart[
              itemsInCartCount < 1 ? "addClass" : "removeClass"
            ]("header__count");

            const addedItem = Object.entries(itemsInCart).filter(
              (item) => item[1].id === id
            );

            // Analytics. Add to cart. add_to_cart. addToCart
            GAAddToCart(addedItem[0], response.common);
            FacebookPixel.addToCart(addedItem);
            eSputnik.StatusCart(itemsInCart, new GUID());

            modalCart.open({
              response,
              isNewProduct: true,
              shouldOpen: true,
            });
            setTimeout(() => {
              window.productsIDs.push(id);
              isAdded([id]);
            }, 500)

          } catch (error) {
            // eslint-disable-next-line no-console
            console.log("Error add to cart", error);
            // Remove from productsIDs
            window.productsIDs = window.productsIDs.filter(
              (productId) => productId !== id
            );
            isRemoved(id);
          } finally {
            isAddingToCart = false;
          }
        }
      }
    );

  };

  const productSocial = () => {
    const opener = $(".social__opener")

    opener.on("click", function openSocialMenu() {
      $(this).parents(".social").toggleClass("active")
    })
  }

  const anchor = () => {
    const anchorButton = $(".anchor")

    anchorButton.on("click", function animateScroll(e) {
      e.preventDefault()
      const target = $(this).attr("href")
      const { top } = $(target).position()
      const headerHeight = $(".header").height()

      $("body,html").animate({ scrollTop: top - headerHeight }, 500)
    })
  }

  const mobileChar = () => {
    const opener = $(".about-item__title")

    opener.on("click", function openCharMenu() {
      $(this).parents(".about-item").toggleClass("active")
    })
  }

  const reviews = () => {
    /**
     * Handles error messages for the form.
     *
     * @param {HTMLElement} formEl - The form element.
     * @param {string} [errorText=""] - The error message text.
     */
    const setErrorMessage = (formEl, errorText = "") => {
      const errorHolder = formEl.querySelector(".review-form__error")
      errorHolder.textContent = errorText
    }

    const reviewsAccordion = () => {
      // Reviews accordion with event delegate
      const reviewsBox = document.querySelector(".js_product_reviews_list")
  
      if (!reviewsBox) return
  
      // Go through all reviews and check if content height more than block height
      // Add more button if true
      const commentElList = reviewsBox.querySelectorAll(
        ".reviews-card, .reviews-card__response",
      )
      commentElList.forEach((commentEl) => {
        const commentContent = commentEl.querySelector(".reviews-card__content")
        const commentContentHeight = commentContent.offsetHeight
        const commentContentScrollHeight = commentContent.scrollHeight
  
        if (commentContentScrollHeight > commentContentHeight) {
          const moreButton = commentEl.querySelector(".reviews-card__more")
          moreButton.style.display = "block"
        }
      })
  
      // Add event to reviews list with delegate
      reviewsBox.addEventListener("click", ({ target }) => {
        const moreButton = target.closest(".reviews-card__more")
  
        if (moreButton) {
          const commentContent = moreButton
            .closest(".reviews-card, .reviews-card__response")
            .querySelector(".reviews-card__content")
          commentContent.classList.toggle("active")
          moreButton.classList.toggle("active")
        }
      })
    }

    const fileReader = () => {
      
      /**
       * Remove image from input file
       * @param {Event} e - Event object
       * @returns {void}
       */
      const removeFile = (e) => {
        const imgEl = e.target.parentElement.querySelector("img")
        const isFull = imgEl.getAttribute("src") !== ""

        if (isFull) {
          e.preventDefault?.()
          imgEl.setAttribute("src", "")
          e.target.value = ""
          const labelElement = e.target.closest("label")
          labelElement.classList.remove("is-full")
          labelElement.parentNode.appendChild(labelElement.cloneNode(true))
          labelElement.remove()
        }
      }

      /**
       * Read image from input file
       * @param {Event} e - Event object
       * @returns {void}
       */
      const readImage = (e) => {
        const refsReviews = {
          formEl: e.target.closest("form"),
          fileHolder: e.target.closest(".file-holder"),
          nextImage: e.target.parentElement.querySelector("img"),
          errorHolder: e.target.closest("form").querySelector(".review-form__error"),
        }

        const { type, size } = e.target?.files[0] ?? {}

        if (size > 5 * 1024 * 1024) {
          // Validate image size max 5MB
          setErrorMessage(refsReviews.formEl, window.phrases.reviews.validation.photo_limit)
          return
        } 
        if (!type.includes("image")) {
          // Validate file type
          setErrorMessage(refsReviews.formEl, window.phrases.reviews.validation.photo_wrong_format)
          return
        } 

        // Reset error message
        refsReviews.errorHolder.textContent = ""
        // Set image src
        const labelElement = e.target.closest("label")
        refsReviews.nextImage.src = URL.createObjectURL(e.target.files[0])
        labelElement.classList.add("is-full")

        // Move label to the first empty label position.
        const labelElementWithEmptyImg = refsReviews.fileHolder
          .querySelector("img[src='']")
          ?.closest("label")
        labelElementWithEmptyImg?.parentNode.insertBefore(
          labelElement,
          labelElementWithEmptyImg,
        )
      }

      /**
       * Erase all file inputs
       * @param {Event} e - Event object
       * @returns {void}
       */
      const resetImage = (e) => {
        const formEl = e.target
        formEl.querySelectorAll(".file-holder input[type='file']").forEach((input) => {
          removeFile({ target: input })
        })
      }

      /**
       * Read image from input file
       */
      addGlobalEvent(
        document.querySelector(".product-reviews"),
        "change",
        ".file-holder input[type='file']",
        readImage
      )

      /**
       * Remove image on click on remove button
       */
      addGlobalEvent(
        document.querySelector(".product-reviews"),
        "click",
        ".file-holder input[type='file']",
        removeFile
      )

      /**
       * Reset image on form reset
       */
      addGlobalEvent(
        document.querySelector(".product-reviews"),
        "reset",
        "form",
        resetImage
      )
    }

    /**
     * Star rating
     * @returns {void}
     */
    const starRating = () => {
      // Remove active class from all stars when form reset
      addGlobalEvent(
        document,
        "reset",
        "form",
        function resetStars(e) {
          const formEl = e.target
          formEl
            .querySelectorAll(".star-rating__item.active")
            .forEach((star) => star.classList.remove("active"))
        },
      )

      const rating = $(".star-rating__item")

      rating.on("click", function setRating() {
        const $this = $(this)
        const value = $this.data("value")
        const parent = $this.parent(".star-rating")
        const valueHolder = parent.find(".star-rating__value")

        if (!parent.hasClass("disabled")) {
          $this.addClass("active")
          $this.prevAll(".star-rating__item").addClass("active")
          $this.nextAll(".star-rating__item").removeClass("active")
          valueHolder.val(value)
          parent.addClass("active")
        }
      })
      //
    }

    /**
     * Load more reviews
     * @returns {void}
     */
    const reviewLoadMore = () => {
      const reviewsBox = document.querySelector(".product-reviews")
      const loadMoreButton = reviewsBox?.querySelector(".js_reviews_load_more")
      if (!loadMoreButton) return

      const reviewsPerPage = 10
      loadMoreButton.addEventListener("click", function loadMoreHandler() {
        const reviewsList = reviewsBox.querySelector(".js_product_reviews_list")
        const reviewsHidden = reviewsList.querySelectorAll(".reviews-card[hidden]")

        reviewsHidden.forEach((review, index) => {
          if (index < reviewsPerPage) {
            review.removeAttribute("hidden")
          }
        })

        if (reviewsHidden.length <= reviewsPerPage) {
          loadMoreButton.style.display = "none"
        }
      })
    }
    
    const reviewFormChangeHandler = (formEl) => {
      const isValid = formEl.checkValidity()
      const submitButton = formEl.querySelector(".product-reviews__submit-btn")

      submitButton.disabled = !isValid
      submitButton.classList.toggle("disabled", !isValid)
    }

    const reviewFormSubmitHandler = async (e) => {
      e.preventDefault()
      const formEl = e.target

      const formData = new FormData(formEl)
      // Remove "rating" input if it's empty
      if (!formData.get("rating")) {
        formData.delete("rating")
      }

      const { token } = await recaptchaEnterprise.executeRecaptcha(RECAPTCHA_ACTIONS.REVIEW)
      renderModalInfoCentered({
        onClose: () => {
          formEl.reset()
          reviewFormChangeHandler(formEl)
        }
      })
      modalInfoCenteredState.setValue((prev) => ({
        ...prev,
        isLoading: true,
        isOpen: false,
      }))

      formData.append("g-recaptcha-response", token)

      $.ajax({
        url: `${AJAX}/api/reviews`,
        type: "POST",
        data: formData,
        contentType: false,
        processData: false,
        headers: {
          "Accept-Language": locale,
        },
        success: (response) => {
          setErrorMessage(formEl)
          modalInfoCenteredState.setValue((prev) => ({
            ...prev,
            phrases: {
              ...response.data.phrases,
              button: window.phrases.general.close
            },
            isLoading: false,
            isOpen: true,
          }))
        },
        error: (error) => {
          // eslint-disable-next-line no-console
          console.log("Error add review", error)
          error.responseJSON && setErrorMessage(formEl, error.responseJSON.message)
          modalInfoCenteredState.setValue((prev) => ({
            ...prev,
            isLoading: false,
          }))

        },
      })
    }

    const resetFormHandler = (e) => {
      const formEl = e.target

      // Update value attributes for email and name inputs
      ;[
        ["email", window.email],
        ["name", window.userName],
      ].forEach(([inputName, initialValue]) => {
        const inputEl = formEl[inputName]
        const val = initialValue || inputEl.value
        inputEl[val ? "setAttribute" : "removeAttribute"]("value", val)
      })
    }

    const initReviewForm = (formEl = document.getElementById("review-form")) => {
      if (!formEl) return
      window.email && formEl["email"].setAttribute("value", window.email)
      window.userName && formEl["name"].setAttribute("value", window.userName)
      formEl.reset()
      reviewFormChangeHandler(formEl)
      formEl.addEventListener("submit", reviewFormSubmitHandler)
      formEl.addEventListener("input", reviewFormChangeHandler.bind(null, formEl))
      formEl.addEventListener("reset", resetFormHandler)
    }

    const destroyReviewForm = (formEl) => {
      if (!formEl) return
      formEl.removeEventListener("submit", reviewFormSubmitHandler)
      formEl.removeEventListener("input", reviewFormChangeHandler)
    }

    const reviewAnswer = () => {
      addGlobalEvent(document, "click", ".js_review_answer_trigger", function handleReviewAnswer(e) {
        const form = document.getElementById("review-form")
        const currentReviewEl = e.target.closest(".reviews-card")
        if (!currentReviewEl || !form) return

        // Check if form already exists in the current review. If true, remove it and return
        const existingForm = currentReviewEl.querySelector(".reviews-card__response form")
        if (existingForm) {
          destroyReviewForm(existingForm)
          existingForm.closest(".reviews-card__response").remove()
          return
        }
        const reviewId = e.target.dataset.id
        const answerBtnText = e.target.textContent
        const footerEl = currentReviewEl.querySelector(".reviews-card__footer")
        // New element
        const reviewAnswerWrapper = document.createElement("div")
        reviewAnswerWrapper.classList.add("reviews-card__response")

        // Copy form after footer
        const formCopy = form.cloneNode(true)
        formCopy.id = `review-form-${reviewId}`
        // Update form title and submit button text
        formCopy.querySelector(".title").textContent = window.phrases.reviews.reply_to_review || answerBtnText
        formCopy.querySelector(".product-reviews__submit-btn").textContent = answerBtnText
        // Erase message
        setErrorMessage(formCopy)
        // Insert form to DOM
        reviewAnswerWrapper.appendChild(formCopy)
        footerEl.insertAdjacentElement("afterend", reviewAnswerWrapper)
        // Init form
        initReviewForm(formCopy)

        // Remove all value attributes from inputs except hidden
        formCopy.querySelectorAll("input").forEach((input) => {
          if (input.type !== "hidden") {
            input.removeAttribute("value")
          }
        })

        // Copy form values with name and email from original form to new form as value attributes
        formCopy["name"].setAttribute("value", form["name"].value)
        formCopy["email"].setAttribute("value", form["email"].value)

        // Add hidden input with reviewId as parent_id 
        const hiddenInput = document.createElement("input")
        hiddenInput.type = "hidden"
        hiddenInput.name = "parent_id"
        hiddenInput.value = reviewId
        formCopy.appendChild(hiddenInput)

      })
    }

    const initReviewPhotoSlider = () => {
      // reviews-card__images
      addGlobalEvent(
        document.querySelector(".product-reviews"),
        "click",
        ".js_review_img_link",
        function openReviewPhotoSlider(e) {
          e.preventDefault()
          const images = Array.from(
            e.target.closest(".reviews-card__images").querySelectorAll("img"),
          )
          const imageIndex = images.indexOf(e.target)
          // const imagesArr = images.map((img) => img.src)
          const imagesAlt = images.map((img) => img.alt)
          const imagesXLArr = images.map((img) => img.dataset.large)
          const imagesXLWebpArr = images.map((img) => img.dataset.largeWebp)

          modalPreviewSlider(imagesXLArr, imageIndex, imagesAlt, imagesXLWebpArr)
        },
      )
    }

    const initReviewVote = () => {
      
      addGlobalEvent(
        document.querySelector(".product-reviews"),
        "click",
        ".js_review_answer_vote",
        function toggleFavorite() {
          const reviewId = this.dataset.id

          $.ajax({
            url: `${AJAX}/api/reviews/${reviewId}/vote`,
            type: "GET",
            dataType: "json",
            headers: {
              "Accept-Language": locale,
            },
            success: (response) => {
              const { data } = response
              this.classList.toggle("active", data["is_vote"])
              this.querySelector(".number").textContent = data["vote_count"] || ""
            },
            error: (error) => {
              // eslint-disable-next-line no-console
              console.log("Error vote review", error)
            },
          })
        },
      )
    }

    fileReader()
    initReviewForm()
    reviewAnswer()
    reviewsAccordion()
    starRating()
    reviewLoadMore()
    initReviewPhotoSlider()
    initReviewVote()
  }

  const initPhotoSlider = () => {
    if (window.innerWidth <= 960) {
      const imageSliderEl = document.querySelector(".js_mob_product_photo_slider .swiper")
      if (imageSliderEl) {
        // eslint-disable-next-line no-new
        new Swiper(imageSliderEl, {
          modules: [Pagination, Zoom],
          init: true,
          pagination: {
            el: ".slick-dots",
            renderBullet,
            bulletActiveClass: "slick-active",
            clickable: true,
          },
          zoom: {
            maxRatio: 2,
            toggle: true,
          },
          touchStartPreventDefault: false,
          touchMoveStopPropagation: true,
          on: {
            zoomChange(swiper, scale) {
              const isZoomed = scale > 1
              const activeSlide = swiper.slides[swiper.activeIndex]
              const container = activeSlide.querySelector(".swiper-zoom-container")
              const img = container.querySelector("img")
              const source = container.querySelector("source")

              swiper.allowTouchMove = !isZoomed
              swiper.allowSlideNext = !isZoomed
              swiper.allowSlidePrev = !isZoomed

              if (isZoomed) {
                container.style.touchAction = "none"

                img.dataset.originalSrc = img.dataset.originalSrc || img.src
                img.src = container.dataset.large
                if (source && container.dataset.largeWebp) {
                  source.dataset.originalSrcset = source.dataset.originalSrcset || source.srcset
                  source.srcset = container.dataset.largeWebp
                }
              } else {
                container.style.touchAction = ""

                if (img.dataset.originalSrc) {
                  img.src = img.dataset.originalSrc
                }
                if (source && source.dataset.originalSrcset) {
                  source.srcset = source.dataset.originalSrcset
                }
              }
            }
          }
        })
      }
    }
  }

  const storeSelectorListener = () => {
    $(document).on("click", ".js_stock", function storeSelectorClickHandler(e) {
      e.preventDefault()
      deferAction(() => {
        renderStoreSelector($(this).data("id") || window.currentProduct.value.id)
      })
    })
  }

  productBuy()
  mobileChar()
  anchor()
  productSocial()
  reviews()
  // starRating()
  // fileReader()
  // reviewsAccordion()
  // reviewLoadMore()
  imagePreview()
  sizes()
  initPhotoSlider()
  storeSelectorListener()
}

export default productPage
